module.exports = __webpack_public_path__ + "media/assets_v3/images/auction-list-3-d573793986f5581c8acd59ee098a91c5.png";